"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEV_SEED = exports.DEV_PHRASE = void 0;
// Copyright 2017-2023 @polkadot/keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0

// default substrate dev phrase
const DEV_PHRASE = 'bottom drive obey lake curtain smoke basket hold race lonely fit walk';

// seed from the above phrase
exports.DEV_PHRASE = DEV_PHRASE;
const DEV_SEED = '0xfac7959dbfe72f052e5a0c3c8d6530f202b02fd8f9f5ca3580ec8deb7797479e';
exports.DEV_SEED = DEV_SEED;